<template lang="pug">
v-card.mb-3
  v-card-title.grey.lighten-4.py-0.pr-1(style="min-height: 52px;")
    .title
      v-icon.mr-3.black--text(v-if="extra.icon") {{extra.icon}}
      | {{extra.name}}
    v-spacer
    v-btn(icon @click="open = !open"): v-icon {{open ? 'arrow_drop_down' : 'arrow_drop_up'}}
  v-card-text(v-if="open")
    v-layout(row wrap)
      v-flex(md6 v-for="cat in contents" :key="cat.id")
        v-card(v-if="cat.show" :class="{ 'fill-height': cat.open }")
          v-card-title.grey.lighten-4.py-0.pr-1(style="min-height: 52px;" @click="cat.open = !cat.open")
            v-icon.mr-3(v-if="cat.icon") {{cat.icon}}
            | {{cat.name}}
            v-spacer
            v-btn(icon): v-icon {{cat.open ? 'arrow_drop_down' : 'arrow_drop_up'}}
          v-card-text(v-if="cat.open")
            extra-mein-schreibtisch-prozesse(:categories="cat.children" :contents="cat.contents")
      v-flex(md6 v-if="extra.name === 'Arbeitsorganisation'")
        v-card(:class="{ 'fill-height': open2 }")
          v-card-title.grey.lighten-4.py-0.pr-1(style="min-height: 52px;" @click="open2 = !open2")
            v-icon.mr-3 chrome_reader_mode
            | Online Formulare
            v-spacer
            v-btn(icon): v-icon {{open2 ? 'arrow_drop_down' : 'arrow_drop_up'}}
          v-card-text(v-if="open2")
            ul
              li: a(href="https://hvdbox.de/formulare/dienstreise/index.php") Dienstreise
              li: a(href="https://hvdbox.de/formulare/neueinstellungen/index.php") Neueinstellungen
              li: a(href="https://hvdbox.de/formulare/stellenbeschreibung/index.php") Stellenbeschreibung
              li: a(href="https://hvdbox.de/formulare/ueberlassungen/index.php") Arbeitnehmerüberlassung
              li: a(href="https://hvdbox.de/formulare/urlaubsantrag/index.php") Urlaubsantrag
              li: a(href="https://app.softgarden.io") Softgarden Verwaltung
              li: a(href="https://hvdverband.softgarden.io") Softgarden HVD Landingpage

</template>

<style lang="stylus" scoped>
a
  text-decoration none
</style>

<script>
import ExtraMeinSchreibtischProzesse from './extra-mein-schreibtisch-prozesse'

export default {
  props: {
    extra: Object,
    categories: Array,
  },
  components: {
    ExtraMeinSchreibtischProzesse
  },
  data() {
    return {
      open: true,
      open2: false,
      content: {}
    }
  },
  watch: {
    extra: {
      handler(val) {
        this.content = JSON.parse(this.extra && this.extra.content || null) || {}
      },
      immediate: true,
    }
  },
  computed: {
    contents() {
      if (this.categories) {
        return this.categories
      } else {
        return this.content.arbeitsorganisation
      }
    }
  }
}
</script>
